export const AttributeType = {
  ATTRIBUTE_TYPE_OKR: 5,
  ATTRIBUTE_TYPE_KR: 6,
  ATTRIBUTE_TYPE_PROFILE: 1,
  ATTRIBUTE_TYPE_ACTIVITY: 7,
}

/** Object types whose custom-field list shows the numeric Field ID column (API/public integrations). */
export const ATTRIBUTE_TYPES_SHOWING_FIELD_ID: number[] = [
  AttributeType.ATTRIBUTE_TYPE_PROFILE,
  AttributeType.ATTRIBUTE_TYPE_OKR,
  AttributeType.ATTRIBUTE_TYPE_KR,
  AttributeType.ATTRIBUTE_TYPE_ACTIVITY,
]

export const StatusType = {
  STATUS_ACTIVE: 1,
  STATUS_DELETED: 0,
  STATUS_ARCHIVE: 2,
}

export const FieldTypeAttributes = {
  ATTRIBUTE_TEXT_FIELD: 1,
  ATTRIBUTE_TEXT_AREA: 2,
  ATTRIBUTE_DROPDOWN: 3,
  ATTRIBUTE_MULTI_SELECT: 4,
  ATTRIBUTE_DATE_PICKER: 5
}

export const PermissionsAttributes = {
  PERM_TYPE_ORG: 1,
  ATTRIBUTE_TEAMS: 5,
  ATTRIBUTE_BIZGROUP: 6,
  ATTRIBUTE_VIEW_ALL: 7
}

export const ArchiveStatus = {
  ARCHIVE:2,
  UN_ARCHIVE:1
}

export const EventTracking = {
  CUSTOM_FIELD_PAGE_VIEW:'CUSTOM_FIELD_PAGE_VIEW',
  CUSTOM_FIELD_CREATE:'CUSTOM_FIELD_CREATE',
  CUSTOM_FIELD_ADD:'CUSTOM_FIELD_ADD',
  CUSTOM_FIELD_CATEGORY_CREATE:'CUSTOM_FIELD_CATEGORY_CREATE',
  CUSTOM_FIELD_CATEGORY_ADD:'CUSTOM_FIELD_CATEGORY_ADD',
  CUSTOM_FIELD_CATEGORY_EDIT:'CUSTOM_FIELD_CATEGORY_EDIT',
  CUSTOM_FIELD_EDIT:'CUSTOM_FIELD_EDIT',
  CUSTOM_FIELD_CATEGORY_DELETE:'CUSTOM_FIELD_CATEGORY_DELETE',
  CUSTOM_FIELD_CATEGORY_ARCHIVE:'CUSTOM_FIELD_CATEGORY_ARCHIVE',
  CUSTOM_FIELD_DELETE:'CUSTOM_FIELD_DELETE',
  CUSTOM_FIELD_ARCHIVE:'CUSTOM_FIELD_ARCHIVE',
  CUSTOM_FIELD_REORDER:'CUSTOM_FIELD_REORDER',
  CUSTOM_FIELD_CATEGORY_REORDER:'CUSTOM_FIELD_CATEGORY_REORDER'
}
